import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';


@Component({
	selector: 'app-new-name',
	templateUrl: './new-name.component.html',
	styleUrls: ['./new-name.component.scss']
})
export class NewNameComponent implements OnInit {
	addname: FormGroup;
	submitted = false;
	manual_one_checked = false;
	manual_two_checked = false;
	manual_three_checked = false;
	getallname: any;
	editFG: FormGroup;
	nameData: any;
	constructor(
		private modalService: NgbModal,
		private fb: FormBuilder,
		private local: LocalServiceService,
		private router: Router,
		private auth: AuthServiceService,
		private toastr: ToastrService,
	) { }
	closeResult = '';

	ngOnInit(): void {
		this.getAllname()
		this.addname = this.fb.group({
			name: ["", [Validators.required]],
			//phno: ["", [Validators.required]],
			phno: ["", [Validators.required, Validators.pattern('[- +()0-9]+')]],
		})

		this.editFG = this.fb.group({
			amount: [this.nameData?.amount, [Validators.required]],
			name: [this.nameData?.name, [Validators.required]],
			nameId: [this.nameData?.id],
			manual_one: [this.nameData?.manual_one],
			manual_two: [this.nameData?.manual_two],
			manual_three: [this.nameData?.manual_three],
		})
	}
	get addnameValidation() { return this.addname.controls }
	get editAmountValidation() { return this.editFG.controls }

	Addname(content: string,) {
		this.modalService.open(content, { size: 'sm', backdrop: 'static' });
	}

	open(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);
	}



	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	getAllname() {
		this.auth.getnameByAdmin().subscribe(
			(response: any) => {
				response.body.getnameByAdmin.map((data) => {
					data.link = environment.baseUrl + `#/user-review-share?u=${btoa(data.phno)}`
					return data
				})
				this.getallname = response.body.getnameByAdmin
				console.log(this.getallname, '--this.getallname---');

			},
			(error) => {
				if (error.status == 401) {
					this.local.logout();
					this.router.navigate(['/admin']);
				}
			}
		);
	}


	saveData() {
		this.submitted = true
		if (this.addname.invalid) {
			return false;
		}
		this.auth.addnameByAdmin(this.addname.value).subscribe(
			(response: any) => {
				this.modalService.dismissAll();
				this.getAllname()
			},
			(error) => {
				console.log(error, '---error--');
				if (error.status == 400) {
					this.toastr.error(error?.error.message)
				}
				if (error.status == 401) {
					this.local.logout();
					this.router.navigate(['/admin']);
				}
			}
		);
	}

	delName(id) {

		this.auth.deletenameByAdmin(id).subscribe(
			(response: any) => {
				this.modalService.dismissAll();
				this.getAllname()
			},
			(error) => {
				if (error.status == 401) {
					this.local.logout();
					this.router.navigate(['/admin']);
				}
			}
		);
	}


	copyToClipboardMessage() {
		this.toastr.success('Copied');
	}

	editAmount(content: string, id: number, data) {
		try {
			console.log('--------in--------');
			this.nameData = data
			this.modalService.open(content, {
				backdropClass: 'light-blue-backdrop',
				size: 'sm',
				// backdrop: 'static',
			});

			this.manual_one_checked = this.nameData.manual_one == 1 ? true : false;
			this.manual_two_checked = this.nameData.manual_two == 1 ? true : false;
			this.manual_three_checked = this.nameData.manual_three == 1 ? true : false;

			this.editFG.patchValue({
				amount: this.nameData.amount ? this.nameData.amount : "0",
				name: this.nameData.name ? this.nameData.name : "",
				nameId: this.nameData.id ? this.nameData.id : 0,
				manual_one: this.nameData.manual_one ? this.nameData.manual_one : 0,
				manual_two: this.nameData.manual_two ? this.nameData.manual_two : 0,
				manual_three: this.nameData.manual_three ? this.nameData.manual_three : 0,
			});
		} catch (error) {
			console.log(error, '------error--------------');
		}
	}

	updateAmount() {
		this.submitted = true
		if (this.editFG.invalid) {
			return false;
		}

		console.log(this.editFG.value, '---this.editFG.value--');

		this.auth.updateAmountByAdmin(this.editFG.value).subscribe(
			(response: any) => {
				this.modalService.dismissAll();
				this.getAllname()
			},
			(error) => {
				if (error.status == 401) {
					this.local.logout();
					this.router.navigate(['/admin']);
				}
			}
		);
	}

	openLink(link: string) {
		return link.replaceAll('/#', '')
	}

}
